import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function OldSolutionsSection() {
  const solutions = [{
    title: '“Solo respira”',
    why: 'Sin un guion claro, lo abandonas en 60 segundos cuando la ansiedad aprieta.'
  }, {
    title: 'Journaling libre',
    why: 'Sin límites, se vuelve una excavación emocional y terminas peor que al empezar.'
  }, {
    title: 'Celular para desconectar',
    why: 'Te mete estímulo, comparación y luz azul. Más ruido para tu mente.'
  }, {
    title: '“Relájate”',
    why: 'Es un consejo vago, no un protocolo. No te falta voluntad, te falta un método.'
  }];
  return <section className="py-24 px-6 bg-[#0c1220] relative" data-id="element-78">
      <div className="max-w-5xl mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-80">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#f5efe3]" data-id="element-81">
            Por qué lo que intentaste antes falla <br data-id="element-82" />
            <span className="text-[#8b9bb4] text-2xl md:text-3xl font-normal font-serif italic" data-id="element-83">
              (aunque sea "bueno")
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-84">
          {solutions.map((sol, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#111827] p-6 rounded-xl border border-white/5 hover:border-[#c9956b]/30 transition-colors" data-id="element-85">
              <div className="flex items-center gap-3 mb-4" data-id="element-86">
                <div className="w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center" data-id="element-87">
                  <X className="w-4 h-4 text-red-400" data-id="element-88" />
                </div>
                <h3 className="font-bold text-[#f0e6d3]" data-id="element-89">{sol.title}</h3>
              </div>
              <p className="text-[#8b9bb4] text-sm leading-relaxed" data-id="element-90">
                {sol.why}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-16 text-center" data-id="element-91">
          <p className="text-xl text-[#f0e6d3]" data-id="element-92">
            No te falta fuerza de voluntad. <br data-id="element-93" />
            <span className="text-[#c9956b] font-serif text-2xl italic" data-id="element-94">
              Te falta un candado.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}